export function getEnumValues<T = string>(enumAsObj: Record<string, T>): T[]{
	return Object.keys(enumAsObj).map((k: string): T => enumAsObj[k]);
}